export default (element_id, offset) => {
	offset = offset == undefined ? 0 : offset;
    window.scrollTo({
        top: document.getElementById(element_id).offsetTop - 100 + offset,
        behavior: "smooth"
    });
};